import React, { useState } from 'react';
import '../styles/tooltip.css';

interface TooltipProps {
  content: string | React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export default function Tooltip({ content, position = 'bottom' }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="tooltip-container">
      <span 
        className="info-icon" 
        onClick={() => setIsVisible(!isVisible)}
      >
        ⓘ
      </span>
      {isVisible && (
        <div className={`tooltip-popup tooltip-${position}`}>
          {content}
          <button 
            className="tooltip-close"
            onClick={(e) => {
              e.stopPropagation();
              setIsVisible(false);
            }}
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
}

